




































































import { ContractedSubscription } from '@/models/order/subscription/contracted/contracted-subscription'
import { formatPrice } from '@/util/format'
import { buildLabelFrom, Label } from '@spa/components/pages/mypage/subscription/contracted/list/model/list-item/label'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class ContractedSubscriptionDetailContent extends Vue {
  @Prop({ required: true })
  contractedSubscription: ContractedSubscription

  readonly formatPrice = formatPrice

  get labels(): Label {
    return buildLabelFrom(this.contractedSubscription)
  }

  @Emit()
  unapply() {
    // only emit
  }
}
